import { Link } from "react-router-dom";
import type { Journey } from "@/types/content";

interface JourneyCardProps {
  journey: Journey;
  index?: number;
}

export default function JourneyCard({ journey, index = 0 }: JourneyCardProps) {
  return (
    <article className="group flex h-full flex-col">
      <Link
        to={`/culinary-journeys/${journey.slug}`}
        className="block overflow-hidden image-zoom"
        aria-label={`View journey: ${journey.city}`}
      >
        <div className="relative aspect-[4/5] w-full overflow-hidden bg-foreground-900">
          <img
            src={journey.image}
            alt={`${journey.city} — ${journey.title}`}
            title={`${journey.city} culinary journey`}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />

          <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 font-label text-[10px] uppercase tracking-label text-foreground-950">
            {journey.category}
          </span>

          <span className="absolute right-4 top-4 font-label text-[11px] uppercase tracking-label text-background-50">
            {journey.dateLabel}
          </span>

          <div className="absolute inset-x-0 bottom-0 p-5">
            <span className="block font-label text-[10px] uppercase tracking-label text-background-50/70">
              {String(index + 1).padStart(2, "0")} / {journey.region}
            </span>
          </div>
        </div>
      </Link>

      <div className="mt-6 flex flex-1 flex-col">
        <h3 className="font-heading text-2xl md:text-3xl leading-tight text-foreground-950">
          {journey.city}
        </h3>
        <p className="mt-2 font-body text-sm leading-relaxed text-foreground-700">
          {journey.excerpt}
        </p>
        <Link
          to={`/culinary-journeys/${journey.slug}`}
          className="link-underline mt-6 inline-flex w-fit items-center gap-2 font-label text-[11px] uppercase tracking-label text-primary-600"
        >
          View Journey
          <i className="ri-arrow-right-line text-base" />
        </Link>
      </div>
    </article>
  );
}